import React, { useState, useEffect, useRef } from "react";
import { useTheme } from "@material-ui/core/styles";
import {
  BarChart,
  CartesianGrid,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Label,
  ResponsiveContainer,
} from "recharts";
import { startOfHour, parseISO, format } from "date-fns";
import { i18n } from "../../translate/i18n";
import Title from "./Title";
import useTickets from "../../hooks/useTickets";

const INITIAL_CHART_DATA = Array.from({ length: 24 }, (_, i) => ({
  time: `${String(i).padStart(2, "0")}:00`,
  amount: 0,
}));

const Chart = () => {
  const theme  = useTheme();
  const date   = useRef(new Date().toISOString());
  const { tickets } = useTickets({ date: date.current });

  const [chartData, setChartData] = useState(INITIAL_CHART_DATA);

  useEffect(() => {
    // Reseta os valores antes de recontabilizar — evita acumulação incorreta
    const reset = INITIAL_CHART_DATA.map((item) => ({ ...item }));

    tickets.forEach((ticket) => {
      const hour = format(startOfHour(parseISO(ticket.createdAt)), "HH:mm");
      const slot = reset.find((a) => a.time === hour);
      if (slot) slot.amount++;
    });

    setChartData(reset);
  }, [tickets]);

  return (
    <React.Fragment>
      <Title>
        {`${i18n.t("dashboard.charts.perDay.title")}${tickets.length}`}
      </Title>
      <ResponsiveContainer>
        <BarChart
          data={chartData}
          barSize={20}
          margin={{ top: 16, right: 16, bottom: 0, left: 24 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.divider} />
          <XAxis
            dataKey="time"
            stroke={theme.palette.text.secondary}
            tick={{ fontSize: 11 }}
            interval={2}
          />
          <YAxis
            type="number"
            allowDecimals={false}
            stroke={theme.palette.text.secondary}
            tick={{ fontSize: 11 }}
          >
            <Label
              angle={270}
              position="left"
              style={{ textAnchor: "middle", fill: theme.palette.text.secondary, fontSize: 12 }}
            >
              Tickets
            </Label>
          </YAxis>
          <Tooltip
            contentStyle={{
              backgroundColor: theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: 8,
              fontSize: 13,
            }}
            cursor={{ fill: theme.palette.action.hover }}
            formatter={(value) => [value, "Tickets"]}
            labelFormatter={(label) => `Horário: ${label}`}
          />
          <Bar dataKey="amount" fill={theme.palette.primary.main} radius={[3, 3, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
};

export default Chart;
